/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';
import { getMappingConfig } from '../../admin/inventories/mappingUtils';

/**
 * Custom hook to manage operation data state
 */
export function useOperationData(inventoryData, containerId) {
  // Initialize inventory data with migrated config
  const [currentInventoryData, setCurrentInventoryData] = useState(() => {
    const mappingConfig = getMappingConfig(inventoryData);
    return mappingConfig ? { ...inventoryData, mappingConfig } : inventoryData;
  });

  const [currentContainerData, setCurrentContainerData] = useState();

  useEffect(() => {
    const newCurrentContainer = currentInventoryData.containersArray.find(
      (container) => container.id === containerId,
    );
    setCurrentContainerData(newCurrentContainer);
  }, [currentInventoryData, containerId]);

  const currentContainer = () => currentInventoryData.containersArray.find(
    (container) => container.id === containerId,
  );

  const getContainerId = (item) => {
    const ivtContainerIdMapping = currentInventoryData.mappingConfig.columns.ivtContainerId.mapping.csvName;
    if (Array.isArray(ivtContainerIdMapping)) {
      return ivtContainerIdMapping.map((colName) => item[colName]).join(' / ');
    }
    return item[ivtContainerIdMapping];
  };

  const getContainerUrlPathReference = (item) => {
    const ivtContainerIdMapping = currentInventoryData.mappingConfig.columns.ivtContainerId.mapping.csvName;
    if (Array.isArray(ivtContainerIdMapping)) {
      return ivtContainerIdMapping.map((colName) => item[colName]).join('_');
    }
    return item[ivtContainerIdMapping];
  };

  return {
    currentInventoryData,
    setCurrentInventoryData,
    currentContainerData,
    setCurrentContainerData,
    currentContainer,
    getContainerId,
    getContainerUrlPathReference,
  };
}
